import React, { useState } from "react";
import EntryColor from "../container/EntryColor";
import ModalOpenBetsChart from "../modals/ModalOpenBetsChart";
import SwitchActiveBetsColum from "../utilities/SwitchActiveBetsColum";
import ButtonOpenBetsBetType from "../utilities/ButtonOpenBetsBetType";

const DailyDouble = ({
  charts,
  getOpenBetsChartModal,
  openBetsChartInfo,
  setOpenBetsChartInfo,
  userInfo,
  idDailyDouble,
  raceNumber,
  raceID,
  voidTickets,
  callTicketVoidListFrom,
  selectedTicketsVoidScore,
  setSelectedTicketsVoidScore,
  selectAllTickets,
  setSelectAllTickets,
  scoreTickets,
  setCallTicketVoidListFrom,
  setSelectionsSelected,
  getCharts,
}) => {
  const [showBetsColumnDD, setShowBetsColumnDD] = useState(false);

  var tableContent = [],
    headersP;

  if (charts) {
    tableContent = charts.map((chart, i) => {
      let selections = chart.Selections.split(",");
      return (
        <tr key={i}>
          <td>
            <EntryColor
              entryNum={parseInt(selections[0])}
              saddleNum={selections[0]}
            />
          </td>
          <td>
            <EntryColor
              entryNum={parseInt(selections[1])}
              saddleNum={selections[1]}
            />
          </td>
          <td style={{ fontWeight: "bold", verticalAlign: "middle" }}>
            ${chart.Amount.toFixed(2)}
          </td>
          {showBetsColumnDD && (
            <td
              style={{ verticalAlign: "middle" }}
              className="cantBets"
              data-toggle="modal"
              data-target="#openBetsChartModal"
              onClick={() => {
                getOpenBetsChartModal(idDailyDouble, chart.Selections);
                setSelectionsSelected(chart.Selections);
              }}
            >
              {chart.BetCount}
            </td>
          )}
        </tr>
      );
    });
  }

  headersP = (
    <tr className="text-center">
      <th>R{raceNumber}</th>
      <th>R{raceNumber + 1}</th>
      <th>Money</th>
      {showBetsColumnDD && <th># Bets</th>}
    </tr>
  );

  return (
    <>
      <ModalOpenBetsChart
        openBetsChartInfo={openBetsChartInfo}
        setOpenBetsChartInfo={setOpenBetsChartInfo}
        userInfo={userInfo}
        wagerTypeId={idDailyDouble}
        voidTickets={voidTickets}
        callTicketVoidListFrom={callTicketVoidListFrom}
        selectedTicketsVoidScore={selectedTicketsVoidScore}
        setSelectedTicketsVoidScore={setSelectedTicketsVoidScore}
        selectAllTickets={selectAllTickets}
        setSelectAllTickets={setSelectAllTickets}
        scoreTickets={scoreTickets}
        setCallTicketVoidListFrom={setCallTicketVoidListFrom}
        getCharts={getCharts}
      />
      <div className="row">
        <div className="col-sm-6">
          <SwitchActiveBetsColum
            showBetsColumn={showBetsColumnDD}
            setShowBetsColumn={setShowBetsColumnDD}
          />
        </div>
        <div className="col-sm-6" style={{ textAlign: "right" }}>
          <ButtonOpenBetsBetType
            ticketType={idDailyDouble}
            raceID={raceID}
            userInfo={userInfo}
            openBetsChartInfo={openBetsChartInfo}
            setOpenBetsChartInfo={setOpenBetsChartInfo}
          />
        </div>
      </div>

      <table className="table table-striped table-sm mt-2">
        <thead>{headersP}</thead>
        <tbody className="table-sm text-center table-bordered">
          {tableContent}
        </tbody>
      </table>
    </>
  );
};

export default DailyDouble;
